import Axios from "@/plugins/axios";
import router from "@/router";
import httpHelper from "@/mixins/httpHelpers";

import tools from "@/mixins/global";
import { sentApiError } from "@/mixins/slack";

export default {
  async getWindowVar({ commit, dispatch }, payload) {
    const result = window.location.pathname.split("/").filter((x) => Boolean(x));
    const pageType = result?.[1] ?? "";
    const pageId = result?.[2] ?? "";
    let type = "";
    let id = "";
    let runId = "";
    let tdmId = "";
    switch (pageType) {
      case "orchestrations-report":
        type = "orchestrations-report";
        id = result?.[2] ?? "";
        runId = result?.[3] ?? "";
        break;
      case "audit-logs":
        type = result?.[2] ?? "";
        id = result?.[3] ?? "";
        break;
      case "load-test":
        type = "project";
        id = result?.[2] ?? "";
        break;
      default:
        id = pageId;
        type = pageType;
    }
    let extraData = "";

    const url = `/uiapi/account/getvariables?type=${type}&id=${id}&runId=${runId}&tdmId=${tdmId}${extraData}`;

    return httpHelper.methods
      .GET(url, {}, payload)
      .then((data) => {
        try {
          const binaryString = atob(data);
          const decodedData = new TextDecoder().decode(
            new Uint8Array([...binaryString].map((char) => char.charCodeAt(0)))
          );

          const flagData = JSON.parse(decodedData);
          if (process.env.NODE_ENV === "development") console.log(flagData);

          // flagData.is_user_tester = false;
          commit("setWindowData", flagData);
          const injectResources = flagData.inject_resources;
          if (injectResources && Array.isArray(injectResources)) {
            injectResources.map((r) => {
              if (r.type === "js") {
                const script = document.createElement("script");
                script.setAttribute("src", r.url);
                script.setAttribute("custom-inject", "true");
                if (r?.attributes) {
                  Object.entries(r?.attributes).map(([key, value]) => {
                    script.setAttribute(key, value);
                  });
                }
                document.body.appendChild(script);
              }
            });
          }

          if (flagData?.checkAccessInfo?.swap_team_id) {
            const _data = flagData.checkAccessInfo;
            const payload = {
              team: {
                name: _data.swap_team_name,
                team_id: _data.swap_team_id,
                user_id: _data.swap_user_id,
                redirect: window.location.pathname,
              },
              onCancel: () => {
                window.location.replace("/v1/projects");
              },
            };
            if (_data?.swap_team_name && _data?.swap_team_id && _data?.swap_user_id) {
              dispatch("switchTeam", payload);
            }
          }

          if (window.ChurnZero && flagData?.churnzero_app_key) {
            window.ChurnZero.push(["setAppKey", flagData.churnzero_app_key]);
            if (flagData?.beaconuseremail && flagData?.current_site_id) {
              window.ChurnZero.push([
                "setContact",
                flagData.current_site_id,
                flagData.beaconuseremail,
              ]);
            } else if (flagData?.beaconuseremail && flagData?.team_id) {
              window.ChurnZero.push(["setContact", flagData.team_id, flagData.beaconuseremail]);
            }
            window.ChurnZero.push([
              "ChurnZeroEvent:on",
              "connected",
              function (data) {
                console.log("ChurnZero connected", data);
                window.userHaveSuccessCenter = data?.hasCenter;
              },
            ]);
          }
          // store to window is window flag is on
          if (!flagData.window) {
            Object.entries(flagData).map(([key, value]) => {
              try {
                if (!window.hasOwnProperty(key)) {
                  Object.defineProperty(window, key, { value, writable: false });
                }
              } catch (e) {
                console.warn("Duplicate ENV", key, value, e.message);
              }
              return null;
            });
            Object.defineProperty(window, "windowVarDone", { value: true, writable: false });
          }
          localStorage.setItem("getvariables-retry", "0");
        } catch (e) {
          if (localStorage.getItem("getvariables-retry") === "0") {
            localStorage.setItem("getvariables-retry", "1");
            dispatch("getWindowVar", payload);
          }
          router.push({ name: "CatchAllRoute" });
          // eslint-disable-next-line no-console
          console.log(e.message);
          console.error("Something went wrong");
        }
      })
      .catch((e) => {
        sentApiError([
          {
            title: "Api EndPoint",
            value: url,
          },
          {
            title: "Payload",
            value: "getvariables",
          },
          {
            title: "Error",
            value: e,
          },
        ]);
        if (localStorage.getItem("getvariables-retry") === "0") {
          localStorage.setItem("getvariables-retry", "1");
          dispatch("getWindowVar", payload);
        }
        if (process.env.NODE_ENV === "development") {
          console.warn("Please check your .env file in vue folders.");
          console.warn(
            "Please check your host file for this entry:\n\n127.0.1.1       local.functionize.com\n\n."
          );
          console.warn(e.message);
        } else {
          router.push({ name: "CatchAllRoute" });
        }
      });
  },
  async getBreadcrumbsData({ commit, state }) {
    const id = router.currentRoute.params.id;
    const type = router.currentRoute.params.type;
    const CSRFToken = state.window.CSRFToken;
    let api_end = "detail";

    if (type === "po") {
      api_end = "po";
    }

    const data = new FormData();
    data.append("id", id);
    data.append("CSRFToken", CSRFToken);

    return Axios.post(`/uiapi/${api_end}/getenvironmentsbreadcum`, data).then((response) => {
      if (response.status === 200) {
        if (response.data instanceof Object) {
          commit("setBreadcrumbsData", response.data);
          return response.data;
        } else {
          return { breadcrumbsData: null };
        }
      } else {
        console.error("Error Getting Breadcrumbs Data");
      }
    });
  },
  commonDialog({ commit }, payload) {
    commit("setCommonDialog", payload);
  },
  swapLogin({ state, dispatch }, { team_id, user_id, redirect }) {
    if (window.ChurnZero) {
      window.ChurnZero.push(["trackEvent", "Logout"]);
      window.ChurnZero.push(["stop"]);
    }

    let ajaxURL = "/account/login/autologin?id=" + user_id + "&team_id=" + team_id + "&tempadmin=1";

    if (user_id === state.window.login_user_id && !state.window.is_user_tester) {
      ajaxURL = "/account/login/swaplogin?team_id=" + team_id + "&tempadmin=1&loginas=1";
    }

    return Axios.post(ajaxURL, tools.methods.formData({ CSRFToken: state.window.CSRFToken }))
      .then((res) => res.data)
      .then((data) => {
        if (data.result === "loginsuccess") {
          if (redirect) window.location.href = redirect;
          else {
            window.location.replace("/v1/projects");
          }
        } else {
          const message = data.actionMsg ?? "Account is expired.";
          dispatch("commonDialog", {
            onSubmit: () => {
              dispatch("commonDialog", { loading: false, show: false }).then(() => {});
            },
            onCancel: false,
            hideOnCancel: true,
            loading: false,
            show: true,
            hide: true,
            contentHTML: `<div class="text-center red--text font-weight-bold">${message}</div>`,
            title: "Warning: Account Expired",
            submitText: "Ok",
          });
        }
      });
  },
  switchTeam({ dispatch }, payload = { team: {} }) {
    const onSubmit = () => {
      // Reset the running tests and make api to fire again
      sessionStorage.removeItem("/account/settings/getloggedinteamrunningtests");
      dispatch("commonDialog", { loading: true, show: false }).then(() => {
        dispatch("swapLogin", payload.team).then(() => {});
      });
    };
    dispatch("commonDialog", {
      show: true,
      contentHTML: `
          <div class="text-center">You are about to switch into team  <b>${payload.team.name}</b>
            <br>
            Click <b>Ok</b> to proceed.
          </div>`,
      title: "Warning: Team Change",
      onSubmit: onSubmit,
      hide: true,
      onCancel: payload.onCancel,
      submitText: "Ok",
      cancelText: "Cancel",
      hideOnCancel: true,
      width: "500px",
    });
  },
};
